import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6cb40e97"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "analysis-wrap"
};
const _hoisted_2 = {
  class: "content title"
};
const _hoisted_3 = {
  class: "match-meta"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 0,
  class: "update-bar"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "update-label"
}, "🕐 最近更新", -1));
const _hoisted_8 = {
  class: "update-time"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "disclaimer"
}, [/*#__PURE__*/_createTextVNode(" ⚠️ 以下盘口与水位均为 AI 基于基本面推演，"), /*#__PURE__*/_createElementVNode("strong", null, "非真实市场数据"), /*#__PURE__*/_createTextVNode("，仅供参考 ")], -1));
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
  key: 2,
  class: "no-data"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "推演生成失败，系统将自动重试", -1));
const _hoisted_13 = {
  key: 0,
  class: "err-detail"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "初盘推演将在开售当天 11:00 自动生成", -1));
const _hoisted_15 = {
  class: "err-detail"
};
const _hoisted_16 = {
  key: 0,
  class: "member-mask"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "member-mask-box"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "member-icon"
}, "🔒"), /*#__PURE__*/_createElementVNode("div", {
  class: "member-title"
}, "会员专属"), /*#__PURE__*/_createElementVNode("div", {
  class: "member-desc"
}, "初盘推演为会员专享功能"), /*#__PURE__*/_createElementVNode("div", {
  class: "member-contact"
}, "联系客服开通会员后解锁查看")], -1));
const _hoisted_18 = [_hoisted_17];
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import apiFoot from '@/utils/apiFoot';
import { showNotify } from '@nutui/nutui';
export default {
  __name: 'OpeningAnalysisView',
  setup(__props, {
    expose: __expose
  }) {
    const store = useStore();
    const isVisible = ref(false);
    const loading = ref(false);
    const matchId = ref('');
    const homeTeam = ref('');
    const awayTeam = ref('');
    const league = ref('');
    const matchNumStr = ref('');
    const matchTime = ref('');
    const plannedTime = ref('');
    const updateTime = ref('');
    const content = ref('');
    const status = ref(null);
    const lastError = ref('');
    const isMember = computed(() => store.state.fullUser);
    const show = id => {
      matchId.value = id;
      isVisible.value = true;
      loading.value = true;
      content.value = '';
      status.value = null;
      lastError.value = '';
      updateTime.value = '';
      fetchOpening();
    };
    const close = () => {
      isVisible.value = false;
    };
    const fetchOpening = async () => {
      try {
        // apiFoot 自动附加签名并解密加密响应，data 即原始 {matchInfo, item}
        const data = await apiFoot.get('/openingAnalysis/list', {
          params: {
            matchId: matchId.value
          }
        });
        const info = data.matchInfo || {};
        homeTeam.value = info.homeTeam || '';
        awayTeam.value = info.awayTeam || '';
        league.value = info.league || '';
        matchNumStr.value = info.matchNumStr || '';
        matchTime.value = info.matchTime || '';
        plannedTime.value = info.plannedTime || '';
        const item = data.item || null;
        content.value = item && item.content || '';
        status.value = item ? item.status : null;
        lastError.value = item && item.lastError || '';
        updateTime.value = item && item.updateTime || '';
      } catch (e) {
        console.error('获取初盘推演失败', e);
        showNotify.warn('初盘推演加载失败，请稍后重试');
      } finally {
        loading.value = false;
      }
    };

    // Markdown 渲染：项目未引入 marked，沿用组件内手写正则的方案
    const renderMarkdown = text => {
      if (!text) return '';
      let t = text;
      // 标题
      t = t.replace(/^###### (.*)$/gm, '<h6>$1</h6>');
      t = t.replace(/^##### (.*)$/gm, '<h5>$1</h5>');
      t = t.replace(/^#### (.*)$/gm, '<h4>$1</h4>');
      t = t.replace(/^### (.*)$/gm, '<h3>$1</h3>');
      t = t.replace(/^## (.*)$/gm, '<h2>$1</h2>');
      // 引用（报告开头的免责声明）
      t = t.replace(/^> (.*)$/gm, '<blockquote>$1</blockquote>');
      // 代码块（先处理，避免内部被其它正则污染）
      t = t.replace(/```(\w*)\n([\s\S]*?)```/g, (m, lang, code) => `<pre><code class="${lang || ''}">${code.trim()}</code></pre>`);
      // 表格：连续 | 行合并为一个 table，首行渲染为表头
      t = t.replace(/((?:\|[^\n]*\|\n?)+)/g, m => {
        const rows = m.trim().split('\n').filter(r => r.trim().startsWith('|'))
        // 过滤 |---|---| 分隔行，否则会被渲染成一行空单元格的假表头
        .filter(r => !/^\|[\s:|-]+\|$/.test(r.trim()));
        if (!rows.length) return m;
        const trs = rows.map((r, idx) => {
          const cells = r.replace(/^\||\|$/g, '').split('|').map(c => c.trim());
          const tag = idx === 0 ? 'th' : 'td';
          return '<tr>' + cells.map(c => `<${tag}>${c}</${tag}>`).join('') + '</tr>';
        }).join('');
        return `<table>${trs}</table>`;
      });
      // 无序列表（连续项合并）
      t = t.replace(/((?:^[-*] .*(?:\n|$))+)/gm, m => {
        const items = m.replace(/^[-*] /gm, '').split('\n').filter(Boolean).map(x => `<li>${x}</li>`).join('');
        return `<ul>${items}</ul>`;
      });
      // 有序列表（连续项合并）
      t = t.replace(/((?:^\d+\. .*(?:\n|$))+)/gm, m => {
        const items = m.replace(/^\d+\. /gm, '').split('\n').filter(Boolean).map(x => `<li>${x}</li>`).join('');
        return `<ol>${items}</ol>`;
      });
      // 加粗（放在表格之后，单元格内的 **xx** 也能生效）
      t = t.replace(/\*\*(.*?)\*\*/gm, '<strong>$1</strong>');
      return t;
    };
    const formatTime = t => t ? t.replace(/^\d{4}-/, '') : '';
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      const _component_var_loading = _resolveComponent("var-loading");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createBlock(_component_nut_popup, {
        visible: isVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => isVisible.value = $event),
        closeable: "",
        style: {
          padding: '50px 12px 20px',
          height: '88%',
          width: '92%',
          overflowY: 'auto',
          overflowX: 'hidden'
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
          class: _normalizeClass(['analysis-content', {
            'is-blurred': !isMember.value
          }])
        }, [_createVNode(_component_var_loading, {
          description: "加载中",
          loading: loading.value
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString(homeTeam.value) + " vs " + _toDisplayString(awayTeam.value), 1), _createElementVNode("div", _hoisted_3, [matchNumStr.value ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(matchNumStr.value) + " · ", 1)) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(league.value) + " ", 1), matchTime.value ? (_openBlock(), _createElementBlock("span", _hoisted_5, " · 开赛 " + _toDisplayString(matchTime.value), 1)) : _createCommentVNode("", true)]), updateTime.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _createElementVNode("span", _hoisted_8, _toDisplayString(formatTime(updateTime.value)), 1)])) : _createCommentVNode("", true), content.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_hoisted_9, _createElementVNode("div", {
            class: "markdown-content",
            innerHTML: renderMarkdown(content.value)
          }, null, 8, _hoisted_10)], 64)) : !loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [status.value === 2 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_hoisted_12, lastError.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(lastError.value), 1)) : _createCommentVNode("", true)], 64)) : plannedTime.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_hoisted_14, _createElementVNode("div", _hoisted_15, "计划生成时间：" + _toDisplayString(plannedTime.value), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 2
          }, [_createTextVNode("暂无推演结果")], 64))])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["loading"])], 2), !isMember.value ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18)) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};